import React, { HTMLProps, SyntheticEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { ApplicationState } from 'reducers';
import { getAdminMinioCredentials_getAdminMinioCredentials } from '@api/graphql/types';
import { connect, DispatchProp } from 'react-redux';
import ImagePreview from '@components/ImagePreview';
import FileModal from '@components/FileModal';

interface PropType {
    name: string;
    value: string | null | undefined;
    placeholder?: string;
    prefix: string | undefined;
    type: 'image' | 'file';
    text?: string;
    hint?: string;
    onChangeHandler: (value: any, name: string) => void;
}

interface ReduxProps {
    credentials: getAdminMinioCredentials_getAdminMinioCredentials | null;
}

type Props = ReduxProps & PropType & DispatchProp & InjectedIntlProps;

interface State {
    imageModal: {
        visible: boolean;
        url: string;
    };
    fileModal: {
        visible: boolean;
    };
}

class FileSelector extends React.Component<HTMLProps<HTMLInputElement> & Props, State> {
    public state = {
        imageModal: {
            visible: false,
            url: '',
        },
        fileModal: {
            visible: false,
        },
    };
    public render() {
        const { value, hint, prefix } = this.props;
        return (
            <div className="row">
                <div className="col-sm-6">
                    <button className="btn btn-primary btn-block" onClick={(e: SyntheticEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setState({fileModal: {visible: true}});
                    }}>{this.props.text ? this.props.text : this.props.intl.formatMessage({ id: (value ? 'common.update' : 'common.upload') })}</button>
                    {hint && <span className="form-text m-b-none">{hint}</span>}
                </div>

                <div className="col-sm-4">
                    {this.props.type === 'image' ?
                        <ImagePreview url={value || ''} /> :
                        <span>{value ? <a href={value} target="_balnk">{value}</a> : ''}</span>
                    }
                </div>
                {this.state.fileModal.visible && (
                    <FileModal
                        visible={this.state.fileModal.visible}
                        value={value}
                        prefix={prefix}
                        type={this.props.type}
                        onClose={() => {
                            this.setState({fileModal: {visible: false}});
                        }}
                        onSubmit={(val: string) => {
                            this.props.onChangeHandler(val, this.props.name);
                        }}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ file }: ApplicationState): { credentials: getAdminMinioCredentials_getAdminMinioCredentials | null } => {
    return { credentials: file.credentials };
};

export default compose(
    injectIntl,
    connect(mapStateToProps),
)(FileSelector);



// WEBPACK FOOTER //
// ./src/components/Form/FileSelector.tsx